// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3WjOK","label":"Completed_label__1eNdu"};